var _style, _text, _text2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _text3, _text4, _text5, _text6, _rect26, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _text18, _text19, _text20, _text21, _text22, _text23, _text24, _text25, _text26, _text27, _text28, _text29, _text30, _text31, _text32, _text33, _text34, _text35, _text36, _text37, _text38, _text39, _text40, _text41, _text42, _text43, _text44, _text45, _text46, _text47, _text48, _text49, _text50, _text51, _text52, _text53, _text54, _text55, _text56, _text57, _text58, _text59, _text60, _text61, _text62, _text63, _text64, _text65, _text66, _text67, _text68, _text69, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _rect27, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _text70, _text71, _text72, _text73, _rect34;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrganigramme(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1349.4 951.2",
    style: {
      enableBackground: "new 0 0 1349.4 951.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{font-family:'ArialMT';}\r\n\t.st1{font-size:14px;}\r\n\t.st2{fill:none;}\r\n\t.st3{fill:none;stroke:#000000;}\r\n\t.st4{font-size:16.4238px;}\r\n\t.st5{font-size:9.8543px;}\r\n\t.st6{font-size:13.139px;}\r\n\t.st7{font-size:11.6328px;}\r\n\t.st8{font-size:15.5104px;}\r\n\t.st9{font-size:12.2256px;}\r\n\t.st10{font-size:16.3008px;}\r\n\t.st11{font-size:10.5672px;}\r\n\t.st12{font-size:14.0896px;}\r\n\t.st13{font-size:10.8425px;}\r\n\t.st14{font-size:14.4567px;}\r\n\t.st15{font-size:11.6325px;}\r\n\t.st16{font-size:15.51px;}\r\n\t.st17{font-size:10.1507px;}\r\n\t.st18{font-size:12px;}\r\n\t.st19{font-size:9.0992px;}\r\n\t.st20{font-size:12.1323px;}\r\n\t.st21{fill:none;stroke:#E2001A;stroke-width:2;}\r\n\t.st22{fill:none;stroke:#A10D59;stroke-width:1.75;}\r\n\t.st23{fill:#DE0122;}\r\n\t.st24{fill:#73B220;stroke:#FFED7E;}\r\n\t.st25{fill:#1A171B;stroke:#FFED7E;}\r\n\t.st26{fill:#FFFFFF;stroke:#1D1D1B;stroke-width:3;stroke-miterlimit:10;}\r\n")), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.23,
      enableBackground: "new"
    },
    width: 3509,
    height: 2473,
    xlinkHref: "294D09B7.jpeg",
    transform: "matrix(0.3846 0 0 0.3847 3.9998 0.3306)"
  }), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9739 0 0 1 360.4995 148.6502)",
    className: "st0 st1"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9739 0 0 1 569.7437 153.6903)",
    className: "st0 st1"
  }, "     Chef de l&apos;Etat-Major des Arm\xE9es")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 518.5,
    y: 136.7,
    className: "st2",
    width: 338.5,
    height: 50.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44.1,
    y: 167.9,
    className: "st3",
    width: 236.7,
    height: 37.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44.1,
    y: 299.9,
    className: "st3",
    width: 236.7,
    height: 42.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 44.1,
    y: 374.3,
    className: "st3",
    width: 236.7,
    height: 40
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 543.4,
    y: 414.3,
    className: "st3",
    width: 259.1,
    height: 45.4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1063,
    y: 167.9,
    className: "st3",
    width: 236.7,
    height: 37.8
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 1062.8,
    y: 233.6,
    className: "st3",
    width: 236.7,
    height: 37.8
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 1064.4,
    y: 304.2,
    className: "st3",
    width: 236.7,
    height: 37.8
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 1063,
    y: 415.9,
    className: "st3",
    width: 236.7,
    height: 37.8
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 1062.8,
    y: 483.3,
    className: "st3",
    width: 236.7,
    height: 37.8
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 1063,
    y: 553.9,
    className: "st3",
    width: 236.7,
    height: 37.8
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 741.3,
    y: 337.1,
    className: "st3",
    width: 236.7,
    height: 37.8
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 1026.2,
    y: 728,
    className: "st3",
    width: 236.7,
    height: 37.8
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 554.4,
    y: 726.3,
    className: "st3",
    width: 236.7,
    height: 37.8
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 857.4,
    className: "st3",
    width: 124.8,
    height: 70.6
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 142.1,
    y: 857.4,
    className: "st3",
    width: 124.8,
    height: 70.6
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 271.6,
    y: 857.4,
    className: "st3",
    width: 124.8,
    height: 70.6
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 403.7,
    y: 857.4,
    className: "st3",
    width: 135.1,
    height: 70.6
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 808.9,
    y: 857.4,
    className: "st3",
    width: 135.4,
    height: 70.6
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 545.2,
    y: 856.5,
    className: "st3",
    width: 124.8,
    height: 70.6
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 677.9,
    y: 856.5,
    className: "st3",
    width: 124.8,
    height: 70.6
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 953,
    y: 857.4,
    className: "st3",
    width: 124.8,
    height: 70.6
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 1082.6,
    y: 857.4,
    className: "st3",
    width: 124.8,
    height: 70.6
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 1212.1,
    y: 857.4,
    className: "st3",
    width: 124.8,
    height: 70.6
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 84.1,
    y: 726.3,
    className: "st3",
    width: 236.7,
    height: 37.8
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9739 0 0 1 582.7183 432.1883)",
    className: "st0 st4"
  }, "Major G\xE9n\xE9ral des Arm\xE9es")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9739 0 0 1 586.0942 452.8953)",
    className: "st0 st4"
  }, "  VAM GA  Jacquy Honor\xE9")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9739 0 0 1 92.5234 182.9041)",
    className: "st0 st5"
  }, "Directeur de l\u2019\xC9cole d\u2019\xC9tat-Major")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9739 0 0 1 58.1582 198.6707)",
    className: "st0 st6"
  }, "    COL RAFIDISON Alain Bernardin")), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 44.1,
    y: 233.6,
    className: "st3",
    width: 236.7,
    height: 37.8
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9739 0 0 1 49.314 246.9569)",
    className: "st0 st5"
  }, "Directeur du Centre de Perfectinnement des Officiers")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9739 0 0 1 95.5146 262.7234)",
    className: "st0 st6"
  }, "GBR COMPOGE Jojo")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7039 0 0 1 47.291 314.6883)",
    className: "st0 st7"
  }, "Commandant de l&apos;Ecole Nationale des Sous-Officiers de l&apos;Arm\xE9e")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7039 0 0 1 70.5068 333.3006)",
    className: "st0 st8"
  }, "COL RAZAFITOMBO Leva Naina")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9739 0 0 1 60.2661 391.4861)",
    className: "st0 st5"
  }, "Commandant de la Sekoly Miaramilam-Pirenena")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9554 0 0 1 45.9419 407.2537)",
    className: "st0 st6"
  }, "LCL NDRAMANORO Hobindraza Donacien")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9739 0 0 1 1083.2803 179.4168)",
    className: "st0 st5"
  }, "Directeur Central du Commissariat des Arm\xE9es")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.8009 0 0 1 1071.4551 195.1834)",
    className: "st0 st6"
  }, "Intendant-G\xE9n\xE9ral SAMSE ASSIMO Andriamialy")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9739 0 0 1 1308.2568 195.1834)",
    className: "st0 st6"
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9739 0 0 1 1076.2891 248.3953)",
    className: "st0 st5"
  }, "Directeur Interarm\xE9es de la Logistique et du Soutien")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9739 0 0 1 1071.5566 264.1619)",
    className: "st0 st6"
  }, "GBR RAVELONARIVO Gaston Guilliano ")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.6915 0 0 1 1084.3945 317.7156)",
    className: "st0 st9"
  }, "Directeur Interarm\xE9es des Renseignements Militaires")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.6147 0 0 1 1066.4199 337.2772)",
    className: "st0 st10"
  }, "COL RANDRIANARISAONA Elizea Lalaina Ratiarison")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.8207 0 0 1 753.1313 349.7244)",
    className: "st0 st11"
  }, "Directeur du Bureau de Garnison de la Place d\u2019Antananarivo")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.8207 0 0 1 753.7085 366.6326)",
    className: "st0 st12"
  }, "GBR RAKOTONINDRIANA David Rolland")), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 378,
    height: 484,
    xlinkHref: "294D09BA.png",
    transform: "matrix(0.1463 0 0 0.1195 832.5349 279.3941)"
  }), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7067 0 0 1 1067.6836 429.8836)",
    className: "st0 st13"
  }, "Directeur du Bureau de Communication et des Actions Civilo\u2014Militaire")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.6774 0 0 1 1104.5225 447.2322)",
    className: "st0 st14"
  }, "GBR RAFIDIMANANA Teddy Francis")), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.5482 0 0 1 1067.0938 496.7879)",
    className: "st0 st15"
  }, "Directeur du Bureau des t\xE9l\xE9communications et des Syst\xE8mes Informatiques des Arm\xE9es")), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.5087 0 0 1 1104.5176 515.4002)",
    className: "st0 st16"
  }, "GBR RAKOTOMANANA Lovasoa Nantenaina")), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9546 0 0 1 1077.2979 566.201)",
    className: "st0 st13"
  }, "Directeur du Bureau Contr\xF4le et Audit des Arm\xE9es")), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.8796 0 0 1 1090.1816 583.5486)",
    className: "st0 st14"
  }, "GBR RANDRIANASOLO Fran\xE7ois")), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9739 0 0 1 113.2217 739.6697)",
    className: "st0 st5"
  }, "Sous-Chef d\u2019\xC9tat-Major en charge du Plan")), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9739 0 0 1 93.7402 755.4363)",
    className: "st0 st6"
  }, "GBR SOLO Andrianantenaina Angelito")), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9739 0 0 1 571.7026 741.3113)",
    className: "st0 st5"
  }, "Sous-Chef d\u2019\xC9tat-Major en charge de l\u2019Organique")), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9739 0 0 1 561.8511 757.0779)",
    className: "st0 st6"
  }, "  GBR RAMANANTSOA Harifidy Roland")), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9122 0 0 1 1049.1045 741.5604)",
    className: "st0 st17"
  }, "Sous-Chef d\u2019\xC9tat-Major en charge des Op\xE9rations")), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9122 0 0 1 1042.1045 755.9608)",
    className: "st0 st18"
  }, "GDI DERA Zafindravolamananarivelo Didier")), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9532 0 0 1 20.1196 870.4949)",
    className: "st0 st19"
  }, "Directeur du Bureau \xC9tudes")), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9532 0 0 1 54.6606 881.4139)",
    className: "st0 st19"
  }, "et Projets")), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9532 0 0 1 14.2915 895.9725)",
    className: "st0 st20"
  }, "CAM  RAKOTOARISON")), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9532 0 0 1 30.8687 910.532)",
    className: "st0 st20"
  }, " Fran\xE7ois Hubert")), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.987 0 0 1 164.0596 871.8826)",
    className: "st0 st19"
  }, "Directeur du Bureau ")), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.987 0 0 1 154.2617 882.8016)",
    className: "st0 st19"
  }, "Programme et Evaluation")), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.8803 0 0 1 297.667 870.4949)",
    className: "st0 st19"
  }, "Directeur du Bureau ")), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.8803 0 0 1 281.9238 881.4139)",
    className: "st0 st19"
  }, "Pilotage des Restructurations")), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.8803 0 0 1 287.0479 895.9725)",
    className: "st0 st20"
  }, "COL RABENJAMINA  ")), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.8803 0 0 1 320.4805 911.1981)",
    className: "st0 st20"
  }, "Thierry")), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 236,
    height: 293,
    xlinkHref: "294D09A8.png",
    transform: "matrix(0.2287 0 0 0.1897 49.4529 801.2232)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 235,
    height: 292,
    xlinkHref: "294D09A9.png",
    transform: "matrix(0.2282 0 0 0.1921 306.8367 800.4712)"
  }), _text44 || (_text44 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9036 0 0 1 433.1792 869.1072)",
    className: "st0 st19"
  }, "Directeur du Bureau des")), _text45 || (_text45 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9036 0 0 1 437.7427 880.0262)",
    className: "st0 st19"
  }, "Ressources Humaines")), _text46 || (_text46 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7896 0 0 1 405.7246 894.5848)",
    className: "st0 st20"
  }, "COL RAKOTONANDRASANA")), _text47 || (_text47 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9036 0 0 1 441.1313 908.4774)",
    className: "st0 st20"
  }, "Ambinintsoa")), _text48 || (_text48 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9242 0 0 1 562.9331 869.5672)",
    className: "st0 st19"
  }, "Directeur du Bureau des")), _text49 || (_text49 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9242 0 0 1 568.2065 880.4861)",
    className: "st0 st19"
  }, "Soutien et Logistique")), _text50 || (_text50 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9242 0 0 1 554.6401 895.0447)",
    className: "st0 st20"
  })), _text51 || (_text51 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.8213 0 0 1 699.6475 869.1072)",
    className: "st0 st19"
  }, "Directeur du Bureau des")), _text52 || (_text52 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.8213 0 0 1 686.8193 880.0262)",
    className: "st0 st19"
  }, "Domaines et des Infrastructures")), _text53 || (_text53 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.8213 0 0 1 686.1602 894.5848)",
    className: "st0 st20"
  }, "GBR RAHAJANDRAINY ")), _text54 || (_text54 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.8213 0 0 1 683.2773 909.1443)",
    className: "st0 st20"
  }, "Dieudonn\xE9 Jeannot Parfait")), _text55 || (_text55 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7801 0 0 1 833.6211 869.5682)",
    className: "st0 st19"
  }, "Directeur du Bureau des")), _text56 || (_text56 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7801 0 0 1 841.6426 880.4871)",
    className: "st0 st19"
  }, "Finances et Budget")), _text57 || (_text57 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7801 0 0 1 814.8535 895.0457)",
    className: "st0 st20"
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 239,
    height: 302,
    xlinkHref: "294D09AA.png",
    transform: "matrix(0.2234 0 0 0.1863 452.3904 800.8189)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 240,
    height: 300,
    xlinkHref: "294D09AB.png",
    transform: "matrix(0.2201 0 0 0.1905 714.3074 799.2984)"
  }), _text58 || (_text58 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7681 0 0 1 971.9062 869.1072)",
    className: "st0 st19"
  }, "Directeur du Bureau Emploi")), _text59 || (_text59 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7681 0 0 1 998.6016 880.0262)",
    className: "st0 st19"
  }, "des Forces")), _text60 || (_text60 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7681 0 0 1 956.5742 894.5848)",
    className: "st0 st20"
  }, "GBR RAKOTOARIMANANA")), _text61 || (_text61 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7681 0 0 1 981.1279 909.1443)",
    className: "st0 st20"
  }, "Heritiana Daniel")), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 222,
    height: 263,
    xlinkHref: "294D09AF.png",
    transform: "matrix(0.2258 0 0 0.2199 1013.6765 214.1089)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 225,
    height: 265,
    xlinkHref: "294D09A5.png",
    transform: "matrix(0.2259 0 0 0.2159 1014.1462 285.4781)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 231,
    height: 265,
    xlinkHref: "294D09A6.png",
    transform: "matrix(0.22 0 0 0.2173 1012.8757 397.5083)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 226,
    height: 263,
    xlinkHref: "F8226770.png",
    transform: "matrix(0.2252 0 0 0.2193 1012.7439 464.1607)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 230,
    height: 271,
    xlinkHref: "F8226771.png",
    transform: "matrix(0.2214 0 0 0.2135 1012.9265 534.2779)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 229,
    height: 266,
    xlinkHref: "F8226798.png",
    transform: "matrix(0.2191 0 0 0.219 279.8464 213.8765)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 227,
    height: 264,
    xlinkHref: "F8226799.png",
    transform: "matrix(0.2202 0 0 0.2207 279.9128 284.355)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 224,
    height: 263,
    xlinkHref: "F822679A.png",
    transform: "matrix(0.2237 0 0 0.22 279.78 357.1734)"
  }), _text62 || (_text62 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.8608 0 0 1 1110.6885 869.5701)",
    className: "st0 st19"
  }, "Directeur du Centre")), _text63 || (_text63 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.8608 0 0 1 1101.3809 880.4891)",
    className: "st0 st19"
  }, "des Op\xE9rations Militaires")), _text64 || (_text64 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7331 0 0 1 1083.7988 895.0477)",
    className: "st0 st20"
  }, "GBR RANDRIANANTENAINA")), _text65 || (_text65 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7331 0 0 1 1108.459 909.6072)",
    className: "st0 st20"
  }, "F\xE9licien Arthur ")), _text66 || (_text66 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.8531 0 0 1 1233.1074 869.3387)",
    className: "st0 st19"
  }, "Directeur du Bureau de la")), _text67 || (_text67 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.8531 0 0 1 1229.2207 880.2576)",
    className: "st0 st19"
  }, "Planification des Op\xE9rations")), _text68 || (_text68 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.8531 0 0 1 1221.8672 894.8162)",
    className: "st0 st20"
  }, "GBR RAKOTOARISOA ")), _text69 || (_text69 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.8531 0 0 1 1245.1621 909.3758)",
    className: "st0 st20"
  }, "Herinjanahary")), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 271,
    height: 335,
    xlinkHref: "F822679B.png",
    transform: "matrix(0.1915 0 0 0.1717 993.6853 799.6978)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 266,
    height: 331,
    xlinkHref: "F822679F.png",
    transform: "matrix(0.1954 0 0 0.1771 1117.7722 798.4253)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 274,
    height: 336,
    xlinkHref: "F82267A5.png",
    transform: "matrix(0.1897 0 0 0.1752 1245.9373 797.8687)"
  }), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 673.5,
    y1: 183,
    x2: 673.5,
    y2: 329
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 674.1,
    y1: 460.5,
    x2: 674.1,
    y2: 637.3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 203.3,
    y1: 610.4,
    x2: 203.3,
    y2: 638.9
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 1145.3,
    y1: 609,
    x2: 1145.3,
    y2: 638.8
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 1145.3,
    y1: 610,
    x2: 202.3,
    y2: 611.4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 1002.8,
    y1: 176.3,
    x2: 1002.6,
    y2: 315.2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 1013.9,
    y1: 177.2,
    x2: 1002,
    y2: 177.2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 1013.7,
    y1: 243.1,
    x2: 674.5,
    y2: 243.1
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 1014.1,
    y1: 314.4,
    x2: 1001.7,
    y2: 314.4
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 510.2,
    y: 135.1,
    className: "st3",
    width: 329,
    height: 47.7
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 1001.8,
    y1: 425.7,
    x2: 1001.6,
    y2: 564.1
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 1012.9,
    y1: 426.6,
    x2: 1000.9,
    y2: 426.6
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 1012.8,
    y1: 493.5,
    x2: 675.7,
    y2: 493.5
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 1012.9,
    y1: 563.6,
    x2: 1000.6,
    y2: 563.6
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 832.5,
    y1: 307.7,
    x2: 674.5,
    y2: 307.7
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 342,
    y1: 177.2,
    x2: 330,
    y2: 177.2
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 341.9,
    y1: 243,
    x2: 330,
    y2: 243
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 341.8,
    y1: 314.1,
    x2: 329.9,
    y2: 314.1
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 341.9,
    y1: 385.9,
    x2: 329.9,
    y2: 385.9
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 341.2,
    y1: 176.3,
    x2: 341,
    y2: 386.8
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 671.9,
    y1: 281.5,
    x2: 341.8,
    y2: 281.5
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 873.3,
    y1: 782.9,
    x2: 478.6,
    y2: 782.9
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 1272.7,
    y1: 782.9,
    x2: 1019.8,
    y2: 782.9
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 334.8,
    y1: 782.9,
    x2: 75.1,
    y2: 782.9
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 673.5,
    y1: 764.9,
    x2: 673.3,
    y2: 782.9
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 609.3,
    y1: 782.3,
    x2: 609.1,
    y2: 799
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 740.9,
    y1: 782.6,
    x2: 740.7,
    y2: 799.2
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 872.5,
    y1: 782.1,
    x2: 872.3,
    y2: 799.7
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 479.4,
    y1: 782.1,
    x2: 479.2,
    y2: 800.8
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 334,
    y1: 782,
    x2: 333.8,
    y2: 800.5
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 203.4,
    y1: 764.9,
    x2: 203.2,
    y2: 801.4
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 76,
    y1: 782.1,
    x2: 75.8,
    y2: 801.3
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 1019.8,
    y1: 782,
    x2: 1019.6,
    y2: 799.7
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 1143.7,
    y1: 766.3,
    x2: 1143.5,
    y2: 798.3
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 1272.2,
    y1: 782,
    x2: 1272,
    y2: 797.8
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 624.9,
    y: 54.1,
    className: "st23",
    width: 97.3,
    height: 82
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 683,
    height: 557,
    xlinkHref: "F8226794.jpeg",
    transform: "matrix(0.1332 0 0 0.1337 628.5417 57.4498)"
  }), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 624.9,
    y: 332.1,
    className: "st23",
    width: 97.3,
    height: 82
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 499,
    height: 499,
    xlinkHref: "F8226794.jpeg",
    transform: "matrix(0.1844 0 0 0.1543 627.2126 335.0074)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 277,
    height: 302,
    xlinkHref: "F82267B7.jpeg",
    transform: "matrix(0.1721 0 0 0.1805 281.0369 215.7857)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 233,
    height: 264,
    xlinkHref: "F82267B2.png",
    transform: "matrix(0.2151 0 0 0.2192 280.113 148.1734)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 203,
    height: 199,
    xlinkHref: "F82267B3.jpeg",
    transform: "matrix(0.2272 0 0 0.269 281.7917 286.5513)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 291,
    height: 291,
    xlinkHref: "F82267B1.jpeg",
    transform: "matrix(0.165 0 0 0.1861 280.7078 358.9527)"
  }), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 582.2,
    y: 797.5,
    className: "st24",
    width: 54,
    height: 58.7
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 1104.5,
    y: 637.5,
    className: "st25",
    width: 81.7,
    height: 89.7
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 120,
    height: 150,
    xlinkHref: "F82267BF.jpeg",
    transform: "matrix(0.6417 0 0 0.5711 1106.5417 639.1763)"
  }), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 633,
    y: 636.5,
    className: "st25",
    width: 81.7,
    height: 89.7
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 461,
    height: 510,
    xlinkHref: "F82267B1.jpeg",
    transform: "matrix(0.167 0 0 0.1667 635.2078 638.6197)"
  }), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 635.5,
    className: "st25",
    width: 81.7,
    height: 89.7
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 124,
    height: 151,
    xlinkHref: "F82267B3.jpeg",
    transform: "matrix(0.6237 0 0 0.5629 165.2087 637.7876)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 143,
    height: 152,
    xlinkHref: "F82267B1.jpeg",
    transform: "matrix(0.352 0 0 0.3487 308.5417 801.7867)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 133,
    height: 139,
    xlinkHref: "F82267B7.jpeg",
    transform: "matrix(0.3788 0 0 0.3869 453.8738 802.0093)"
  }), _text70 || (_text70 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7542 0 0 1 546.7227 895.0096)",
    className: "st0 st20"
  }, "COL RANDRIAMANANTSOA")), _text71 || (_text71 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.8213 0 0 1 810.8262 896.0096)",
    className: "st0 st20"
  }, "COL RAMAROSANDRATANA")), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 277,
    height: 303,
    xlinkHref: "F82267B3.png",
    transform: "matrix(0.1874 0 0 0.1898 847.0193 798.3638)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 120,
    height: 138,
    xlinkHref: "F82267D6.jpeg",
    transform: "matrix(0.3958 0 0 0.4016 848.9587 799.5806)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 97,
    height: 133,
    xlinkHref: "F82267D6.jpeg",
    transform: "matrix(0.5082 0 0 0.426 1119.0427 799.4673)"
  }), _text72 || (_text72 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7542 0 0 1 572.1318 908.0096)",
    className: "st0 st20"
  }, "Jean de Dieu")), _text73 || (_text73 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.8213 0 0 1 849.6318 908.0096)",
    className: "st0 st20"
  }, "Junior Fils ")), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 367,
    height: 367,
    xlinkHref: "F82267EA.jpeg",
    transform: "matrix(0.134 0 0 0.1533 1247.2078 799.0093)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 457,
    height: 466,
    xlinkHref: "../../../public/images/DCCA/Intendant-G\\xE9n\\xE9ral SAMSE ASSIMO Andriamialy.JPG",
    transform: "matrix(0.1097 0 0 0.1097 1011.1315 153.856)"
  }), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 1169,
    height: 1277,
    xlinkHref: "../../../public/images/cema/GDI \\uD835\\uDDD7\\uD835\\uDDD8\\uD835\\uDDE0\\uD835\\uDDE2\\uD835\\uDDE6\\uD835\\uDDE7\\uD835\\uDDDB\\uD835\\uDDD8\\uD835\\uDDE1\\uD835\\uDDD8 \\uD835\\uDDE3\\uD835\\uDDDC\\uD835\\uDDDE\\uD835\\uDDE8\\uD835\\uDDDF\\uD835\\uDDD4\\uD835\\uDDE6.jpg",
    transform: "matrix(8.924828e-02 0 0 8.924828e-02 621.3848 22.1498)"
  }), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 174.5,
    y: 801.2,
    className: "st26",
    width: 55.6,
    height: 55.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganigramme);
export default __webpack_public_path__ + "static/media/ORGANIGRAMME.c48a40ad193f1d8e0dd89beaafcc7874.svg";
export { ForwardRef as ReactComponent };